import { TDescriptionValue } from 'shared/types/typographyComponents';

export const DESCRIPTION: TDescriptionValue[][] = [
  [
    {
      value:
        'Корпоративным клиентам мы предоставляем доступ к аналитическим инструментам и наборам данных, сформированных на базе собственной платформы',
    },
  ],
  [
    {
      value:
        'Эти продукты позволяют девелоперам и финансовым организациям точнее оценивать рынок, прогнозировать спрос и использовать аналитику в стратегическом управлении',
    },
  ],
];
